import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

import {
  Appointment,
  AppointmentProps,
} from '../../data/patient/domain/appointment/appointment';
import { Patient } from '../../data/patient/domain/patient';
import { MyFacade, MyViewModel } from './my.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-my',
  templateUrl: './my.component.html',
  styleUrls: ['./my.component.scss'],
  providers: [MyFacade],
})
export class MyComponent implements OnInit, OnDestroy {
  patient?: Patient | undefined;
  appointment?: Appointment | undefined;
  public weight?: number;
  public size?: number;
  public isWeightLoading = false;
  public isSizeLoading = false;
  private myStatus$: Observable<MyViewModel>;
  private myStatusSubscription: Subscription;
  private patientSerieItemEventSubscription?: Subscription;

  constructor(private facade: MyFacade, private router: Router) {
    this.myStatus$ = this.facade.myStatus$;
  }

  ngOnInit(): void {
    this.myStatusSubscription = this.myStatus$.subscribe((status) => {
      if (!status.isLoading && status.patient) {
        this.patient = status.patient;
        this.refreshAppointmentDate();
        this.loadActualWeight();
        this.loadActualSize();
        this.initWebNotifications().then();
      }
    });

    this.patientSerieItemEventSubscription =
      this.facade.patientSerieEvent$.subscribe(() => {
        this.loadActualWeight();
        this.loadActualSize();
      });
  }

  ngOnDestroy(): void {
    this.myStatusSubscription?.unsubscribe();
    this.patientSerieItemEventSubscription?.unsubscribe();
  }

  async initWebNotifications() {
    if (!this.patient) {
      return;
    }

    try {
      const notificationWebToken = await this.facade.requestNotification();
      if (!notificationWebToken) {
        return;
      }

      if (this.patient.notificationWebToken !== notificationWebToken) {
        this.patient.notificationWebToken = notificationWebToken;
        return this.facade.updateTokenCurrentPatient(
          this.patient.notificationWebToken,
        );
      }
    } catch (e) {
      console.log('❌ initWebNotifications', e);
      // notification was declined by user
    }
    return;
  }

  signOut() {
    this.facade.signOut().then(() => {
      this.router.navigate(['/auth', 'my']).then();
    });
  }

  private refreshAppointmentDate() {
    if (this.patient) {
      this.facade
        .findAllAppointment(this.patient.id.toString())
        .then((appointments) => {
          if (this.patient) {
            const now = new Date();
            const filteredAppointments = appointments.filter(
              (appointment) => appointment.date > now,
            );
            if (appointments.length > 0) {
              this.appointment = filteredAppointments[0];
            } else {
              this.appointment = Appointment.create({
                date: this.patient.nextAppointment,
              } as AppointmentProps);
            }
          }
        });
    }
  }

  private loadActualWeight() {
    if (!this.patient) {
      return;
    }
    this.isWeightLoading = true;
    this.facade
      .loadActualWeight(this.patient.id.toString())
      .then((data) => {
        this.weight = data;
      })
      .finally(() => {
        this.isWeightLoading = false;
      });
  }

  private loadActualSize() {
    if (!this.patient) {
      return;
    }

    this.isSizeLoading = true;
    this.facade
      .loadActualSize(this.patient.id.toString())
      .then((data) => {
        this.size = data;
      })
      .finally(() => {
        this.isSizeLoading = false;
      });
  }
}
